export default __webpack_public_path__ + "static/media/chevron-up.d2fd742a.svg";